import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { registerLocaleData } from '@angular/common';

import localeNlBe from '@angular/common/locales/nl-BE'
import localeFrFr from '@angular/common/locales/fr';
import localeDeDe from '@angular/common/locales/de';
import localeEsEs from '@angular/common/locales/es';
import localeItIt from '@angular/common/locales/it';
import localeArAe from '@angular/common/locales/ar-AE';
import localeBgBg from '@angular/common/locales/bg';
import localeCaAd from '@angular/common/locales/ca-AD';
import localeZhCn from '@angular/common/locales/zh';
import localeDaDk from '@angular/common/locales/da';
import localeEtEe from '@angular/common/locales/et';
import localeFiFi from '@angular/common/locales/fi';
import localeElGr from '@angular/common/locales/el';
import localeHuHu from '@angular/common/locales/hu';
import localeJaJp from '@angular/common/locales/ja';
import localeHrHr from '@angular/common/locales/hr';
import localeLvLv from '@angular/common/locales/lv';
import localeLtLt from '@angular/common/locales/lt';
import localeMtMt from '@angular/common/locales/mt';
import localeNoNo from '@angular/common/locales/no';
import localePlPl from '@angular/common/locales/pl';
import localePtPt from '@angular/common/locales/pt-PT';
import localeRoRo from '@angular/common/locales/ro';
import localeRuRu from '@angular/common/locales/ru';
import localeSlSi from '@angular/common/locales/sl';
import localeSkSk from '@angular/common/locales/sk';
import localeCsCz from '@angular/common/locales/cs';
import localeTrTr from '@angular/common/locales/tr';
import localeEsAr from '@angular/common/locales/es-AR';
import localeSvAx from '@angular/common/locales/sv-AX';

registerLocaleData(localeNlBe, "nl-BE");
registerLocaleData(localeFrFr, "fr-FR");
registerLocaleData(localeDeDe, "de-DE");
registerLocaleData(localeEsEs, "es-ES");
registerLocaleData(localeItIt, "it-IT");
registerLocaleData(localeArAe, "ar-AE");
registerLocaleData(localeBgBg, "bg-BG");
registerLocaleData(localeCaAd, "ca-AD");
registerLocaleData(localeZhCn, "zh-CN");
registerLocaleData(localeDaDk, "da-DK");
registerLocaleData(localeEtEe, "et-EE");
registerLocaleData(localeFiFi, "fi-FI");
registerLocaleData(localeElGr, "el-GR");
registerLocaleData(localeHuHu, "hu-HU");
registerLocaleData(localeJaJp, "ja-JP");
registerLocaleData(localeHrHr, "hr-HR");
registerLocaleData(localeLvLv, "lv-LV");
registerLocaleData(localeLtLt, "lt-LT");
registerLocaleData(localeMtMt, "mt-Mt");
registerLocaleData(localeNoNo, "no-No");
registerLocaleData(localePlPl, "pl-PL");
registerLocaleData(localePtPt, "pt-PT");
registerLocaleData(localeRoRo, "ro-RO");
registerLocaleData(localeRuRu, "ru-RU");
registerLocaleData(localeSlSi, "sl-SI");
registerLocaleData(localeSkSk, "sk-SK");
registerLocaleData(localeCsCz, "cs-CZ");
registerLocaleData(localeTrTr, "tr-TR");
registerLocaleData(localeEsAr, "es-AR");
registerLocaleData(localeSvAx, "sv-AX");

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

